
// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';

// function OwnerAdd() {
//     const [companyname, setCompanyName] = useState('');
//     const [domain, setDomain] = useState('');
//     const [email, setEmail] = useState('');
//     const [phone, setPhone] = useState('');
//     const [username, setUsername] = useState('');
//     const [firstname, setFirstName] = useState('');
//     const [lastname, setLastName] = useState('');
//     const [password, setPassword] = useState('');
//     const [registerStatus, setRegisterStatus] = useState('');

//     const navigate = useNavigate();

//     const baseUrl = process.env.REACT_APP_BASE_URL || 'http://localhost:5000';

//     const registerowner = async (e) => {
//         e.preventDefault();
    
//         try {
//                 const response = await axios.post(`${baseUrl}/api/tenants/registerowner`, {
//                 companyname,
//                 domain,
//                 username,
//                 email,
//                 phone,
//                 password,
//                 firstname,
//                 lastname,
//             });
    
//             if (response.status === 201) {
//                 setRegisterStatus('ACCOUNT CREATED SUCCESSFULLY');
//                 // setTimeout(() => navigate('/ownerlogin'), 0);
//                 navigate('/ownerlogin');
//             } else if (response.data.message) {
//                 setRegisterStatus(response.data.message);
//                 navigate('/ownerlogin');
//             }
//         } catch (error) {
//             setRegisterStatus('An error occurred during registration.');
//             console.error('Error during registration:', error);
//         }
//     };
    
//     return (
//         <div className="owner-add-container">
//             <div className="card">
//                 <h4 className="hdr hdr--primary hdr--lg">Create Account</h4>
//                 <div className="card-body">
//                     <form onSubmit={registerowner} className="form">
//                         <div className="form-group">
//                             <label htmlFor="companyname">Company Name</label>
//                             <input
//                                 type="text"
//                                 id="companyname"
//                                 value={companyname}
//                                 onChange={(e) => setCompanyName(e.target.value)}
//                                 placeholder="Company Name"
//                                 required
//                             />
//                         </div>
//                         <div className="form-group">
//                             <label htmlFor="domain">Domain</label>
//                             <input
//                                 type="text"
//                                 id="domain"
//                                 value={domain}
//                                 onChange={(e) => setDomain(e.target.value)}
//                                 placeholder="Company Domain"
//                                 required
//                             />
//                         </div>
//                         <div className="form-group">
//                             <label htmlFor="email">Email</label>
//                             <input
//                                 type="email"
//                                 id="email"
//                                 value={email}
//                                 onChange={(e) => setEmail(e.target.value)}
//                                 placeholder="Email Address"
//                                 required
//                             />
//                         </div>
//                         <div className="form-group">
//                             <label htmlFor="phone">Phone</label>
//                             <input
//                                 type="text"
//                                 id="phone"
//                                 value={phone}
//                                 onChange={(e) => setPhone(e.target.value)}
//                                 placeholder="Phone Number"
//                             />
//                         </div>
//                         <div className="form-group">
//                             <label htmlFor="username">Username</label>
//                             <input
//                                 type="text"
//                                 id="username"
//                                 value={username}
//                                 onChange={(e) => setUsername(e.target.value)}
//                                 placeholder="Username"
//                                 required
//                             />
//                         </div>
//                         <div className="form-group">
//                             <label htmlFor="firstname">First Name</label>
//                             <input
//                                 type="text"
//                                 id="firstname"
//                                 value={firstname}
//                                 onChange={(e) => setFirstName(e.target.value)}
//                                 placeholder="First Name"
//                                 required
//                             />
//                         </div>
//                         <div className="form-group">
//                             <label htmlFor="lastname">Last Name</label>
//                             <input
//                                 type="text"
//                                 id="lastname"
//                                 value={lastname}
//                                 onChange={(e) => setLastName(e.target.value)}
//                                 placeholder="Last Name"
//                                 required
//                             />
//                         </div>
//                         <div className="form-group">
//                             <label htmlFor="password">Password</label>
//                             <input
//                                 type="password"
//                                 id="password"
//                                 value={password}
//                                 onChange={(e) => setPassword(e.target.value)}
//                                 placeholder="Password"
//                                 required
//                             />
//                         </div>
//                         <button type="submit" className="btn btn-primary">
//                             Create Owner
//                         </button>
//                         <button onClick={() => navigate('/ownerlogin')} className="btn btn-secondary">
//                             Owner Login
//                         </button>
//                         <button onClick={() => navigate(-1)} className="btn btn-secondary">
//                             Back
//                         </button>
//                         {registerStatus && <p className="status-message">{registerStatus}</p>}
//                     </form>
//                 </div>
//             </div>
//         </div>
//     );
// }

// export default OwnerAdd;

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

function OwnerAdd() {
    const [companyname, setCompanyName] = useState('');
    const [domain, setDomain] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [username, setUsername] = useState('');
    const [firstname, setFirstName] = useState('');
    const [lastname, setLastName] = useState('');
    const [password, setPassword] = useState('');
    // â­ New: Password confirmation state
    const [confirmPassword, setConfirmPassword] = useState('');
    const [registerStatus, setRegisterStatus] = useState('');
    // â­ New: Password match validation state
    const [passwordError, setPasswordError] = useState('');

    const navigate = useNavigate();

    const baseUrl = process.env.REACT_APP_BASE_URL || 'http://localhost:5000';

    /**
     * â­ New: Validate password confirmation in real-time
     * This provides immediate feedback to the user as they type
     */
    const validatePasswordMatch = (pass, confirm) => {
        if (confirm && pass !== confirm) {
            setPasswordError('Passwords do not match');
            return false;
        } else {
            setPasswordError('');
            return true;
        }
    };

    /**
     * â­ Updated: Handle password change with validation
     */
    const handlePasswordChange = (e) => {
        const newPassword = e.target.value;
        setPassword(newPassword);
        // Validate against confirmation if it exists
        if (confirmPassword) {
            validatePasswordMatch(newPassword, confirmPassword);
        }
    };

    /**
     * â­ New: Handle confirm password change with validation
     */
    const handleConfirmPasswordChange = (e) => {
        const newConfirm = e.target.value;
        setConfirmPassword(newConfirm);
        validatePasswordMatch(password, newConfirm);
    };

    const registerowner = async (e) => {
        e.preventDefault();
    
        // â­ New: Validate password confirmation before submission
        if (password !== confirmPassword) {
            setPasswordError('Passwords do not match');
            setRegisterStatus('Please ensure passwords match before submitting.');
            return;
        }

        // â­ New: Validate minimum password length (optional but recommended)
        if (password.length < 8) {
            setPasswordError('Password must be at least 8 characters');
            setRegisterStatus('Password must be at least 8 characters.');
            return;
        }

        try {
                const response = await axios.post(`${baseUrl}/api/tenants/registerowner`, {
                companyname,
                domain,
                username,
                email,
                phone,
                password,
                firstname,
                lastname,
            });
    
            if (response.status === 201) {
                setRegisterStatus('ACCOUNT CREATED SUCCESSFULLY');
                // setTimeout(() => navigate('/ownerlogin'), 0);
                navigate('/ownerlogin');
            } else if (response.data.message) {
                setRegisterStatus(response.data.message);
                navigate('/ownerlogin');
            }
        } catch (error) {
            setRegisterStatus('An error occurred during registration.');
            console.error('Error during registration:', error);
        }
    };
    
    return (
        <div className="owner-add-container" style={{ paddingTop: '80px', paddingBottom: '120px' }}>
            <div className="card">
                <h4 className="hdr hdr--primary hdr--lg">Create Account</h4>
                <div className="card-body">
                    <form onSubmit={registerowner} className="form">
                        <div className="form-group">
                            <label htmlFor="companyname">Company Name</label>
                            <input
                                type="text"
                                id="companyname"
                                value={companyname}
                                onChange={(e) => setCompanyName(e.target.value)}
                                placeholder="Company Name"
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="domain">Domain</label>
                            <input
                                type="text"
                                id="domain"
                                value={domain}
                                onChange={(e) => setDomain(e.target.value)}
                                placeholder="Company Domain"
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="email">Email</label>
                            <input
                                type="email"
                                id="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Email Address"
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="phone">Phone</label>
                            <input
                                type="text"
                                id="phone"
                                value={phone}
                                onChange={(e) => setPhone(e.target.value)}
                                placeholder="Phone Number"
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="username">Username</label>
                            <input
                                type="text"
                                id="username"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                placeholder="Username"
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="firstname">First Name</label>
                            <input
                                type="text"
                                id="firstname"
                                value={firstname}
                                onChange={(e) => setFirstName(e.target.value)}
                                placeholder="First Name"
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="lastname">Last Name</label>
                            <input
                                type="text"
                                id="lastname"
                                value={lastname}
                                onChange={(e) => setLastName(e.target.value)}
                                placeholder="Last Name"
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="password">Password</label>
                            <input
                                type="password"
                                id="password"
                                value={password}
                                onChange={handlePasswordChange}
                                placeholder="Password (min 8 characters)"
                                required
                                minLength={8}
                            />
                            {/* â­ New: Show password requirements hint */}
                            <small className="form-text text-muted">
                                Password must be at least 8 characters long
                            </small>
                        </div>
                        {/* â­ New: Password confirmation field */}
                        <div className="form-group">
                            <label htmlFor="confirmPassword">Confirm Password</label>
                            <input
                                type="password"
                                id="confirmPassword"
                                value={confirmPassword}
                                onChange={handleConfirmPasswordChange}
                                placeholder="Re-enter Password"
                                required
                                minLength={8}
                                // â­ New: Apply error styling if passwords don't match
                                className={passwordError ? 'error' : ''}
                            />
                            {/* â­ New: Display password match error in real-time */}
                            {passwordError && (
                                <small className="form-text text-danger">
                                    {passwordError}
                                </small>
                            )}
                            {/* â­ New: Display success indicator when passwords match */}
                            {confirmPassword && !passwordError && password === confirmPassword && (
                                <small className="form-text text-success">
                                    ✓ Passwords match
                                </small>
                            )}
                        </div>
                        <button 
                            type="submit" 
                            className="btn btn-primary"
                            // â­ New: Disable submit if passwords don't match
                            disabled={password !== confirmPassword || passwordError || !password}
                        >
                            Create Owner
                        </button>
                        <button onClick={() => navigate('/ownerlogin')} className="btn btn-secondary">
                            Owner Login
                        </button>
                        <button onClick={() => navigate(-1)} className="btn btn-secondary">
                            Back
                        </button>
                        {registerStatus && <p className="status-message">{registerStatus}</p>}
                    </form>
                </div>
            </div>
        </div>
    );
}

export default OwnerAdd;